import React, { useState, useEffect, useContext } from "react";
import { ThumbnailPreview, mapBackendTemplateToFrontend } from "components/CommonComponents/CertificatePreview";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Button,
} from "reactstrap";
import { getCertificateTemplateList } from "action/certificate";
import { useDispatch, useSelector } from "react-redux";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";


const CertificateTemplateModal = ({
  isOpen,
  toggle,
  type,
  selectedTemplate,
  onSelect,
}) => {
  const dispatch = useDispatch();
  const { notify } = useContext(NotificationContext);
  const [showPreview, setShowPreview] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  useEffect(() => {
    if (isOpen) {
      // When modal opens, initialize selection from currently applied template
      setPreviewTemplate(selectedTemplate || null);
    }
  }, [isOpen]);

  const certificateTemplateListData = useSelector(
    (state) => state.certificate.certificateTemplateList,
  );

  useEffect(() => {
    if (isOpen) {
      const filters = [];
      if (type) {
        filters.push({
          field: "Type",
          condition: "eq",
          filterValues: [type],
        });
      }
      filters.push({
        field: "Status",
        condition: "eq",
        filterValues: ["ACTIVE"],
      });
      const filterParams = JSON.stringify(filters);
      getCertificateTemplateList(dispatch, null, filterParams);
    }
  }, [dispatch, isOpen, type]);


  const templates = certificateTemplateListData?.data?.CertificateTemplate || [];

  const handleSelectTemplate = (template) => {
    // Toggle: clicking already-selected template deselects it
    setPreviewTemplate((prev) =>
      prev?.ID === template.ID ? null : template
    );
  };

  const handleTemplateClick = (template) => {
    setPreviewTemplate(template);
    setShowPreview(true);
  };

  const handlePreviewCancel = () => {
    setShowPreview(false);
  };

  const handlePreviewApply = () => {
    if (!previewTemplate?.ID) {
      notify( "danger", "Please select a certificate template.");
      return;
    }

    onSelect(previewTemplate);
    setShowPreview(false);
    toggle();
  };

  return (
    <>
      {/* Selection Modal */}
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="xl"
        centered
        className="certificate-template-modal"
      >
        <ModalHeader toggle={toggle}>Select Certificate Template</ModalHeader>

        <ModalBody>
          {templates.length === 0 ? (
            <div className="text-center py-3">
              <i className="fa fa-folder-open fa-3x text-muted mb-3" />
              <h4 className="text-muted mb-0">No templates found</h4>
            </div>
          ) : (
            <Row>
              {templates.map((template, index) => (
                <Col
                  md="4"
                  sm="6"
                  xs="12"
                  className="d-flex justify-content-center mb-4"
                >
                  <div
                    className={`template-card ${
                      previewTemplate?.ID === template.ID ? "active" : ""
                    }`}
                    onClick={() => handleSelectTemplate(template)}
                  >
                    <i
                      className={`check-icon ${
                        previewTemplate?.ID === template.ID
                          ? "fa-solid fa-circle-check"
                          : "fa-regular fa-circle"
                      }`}
                    />

                    <div
                      className="template-preview-thumbnail"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleTemplateClick(template);
                      }}
                    >
                      {(() => {
                        const templateJson =
                          mapBackendTemplateToFrontend(template);

                        return (
                          <div className="certificate-json-preview">
                            <ThumbnailPreview parsedTemplate={templateJson} />
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            className="btn-deep-blue"
            onClick={handlePreviewApply}
          >
            Apply Template
          </Button>
        </ModalFooter>
      </Modal>

      {/* Preview Popup Modal */}
      <Modal
        isOpen={showPreview}
        toggle={handlePreviewCancel}
        size="xl"
        centered
        className="preview-modal"
      >
        <ModalHeader toggle={handlePreviewCancel}>Template Preview</ModalHeader>

        <ModalBody className="text-center p-3">
          {previewTemplate &&
            (() => {
              const templateJson =
                mapBackendTemplateToFrontend(previewTemplate);

              return (
                <div className="template-preview-wrapper">
                  <ThumbnailPreview parsedTemplate={templateJson} />
                </div>
              );
            })()}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handlePreviewCancel}>
            Back
          </Button>
          <Button className="btn-deep-blue" onClick={handlePreviewApply}>
            Apply Template
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CertificateTemplateModal;
